import { dew as _ExchangeTokenRequestDew } from "./ExchangeTokenRequest";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ExchangeTokenRequest = void 0;
  var ExchangeTokenRequest_1 = _ExchangeTokenRequestDew();
  Object.defineProperty(exports, "ExchangeTokenRequest", {
    enumerable: true,
    get: function () {
      return ExchangeTokenRequest_1.ExchangeTokenRequest;
    }
  });
  return exports;
}